import { graphql } from 'react-apollo';
import { waitingFeedPostApprovalsQuery } from '../../students/graphql/waiting-feed-post-approvals.query';
import { FeedPostApprovalsView } from './feed-post-approvals.component';

const withData = graphql(waitingFeedPostApprovalsQuery, {
  name: 'approvals',
  options: {
    pollInterval: 10000,
    fetchPolicy: 'network-only',
  },
});

export const FeedPostApprovals = withData(FeedPostApprovalsView);
